import { render, staticRenderFns } from "./InnerForm.vue?vue&type=template&id=60f2bafe&scoped=true"
import script from "./InnerForm.vue?vue&type=script&lang=js"
export * from "./InnerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f2bafe",
  null
  
)

export default component.exports